<div class="form-back h4" style="font-size: larger;">
    <a class="egd-theme" role="button" routerLink="../license_plans">&#8592; Back</a>
  </div>
<div class="container col-md-12 col-sm-12 bg-white p-5" style="padding: 30px;">
    <div class="form-logo">
        <a href="#">
            <img src="assets/images/logo.png" alt="egd-logo">
        </a>
    </div>
    <div [innerHTML]="this.document_body"></div>
</div>
